import { IVideoPlaylistApiModel } from '@app/Areas/Optimus/ApiClient/VideosClient';
import { ITaskBoardContextModel } from '@app/Areas/Optimus/Apps/TaskBoard/state/TaskBoardReducer/TaskBoardReducer';
import { useTaskBoardStateContext } from '@app/Areas/Optimus/Apps/TaskBoardApp';
import useVaultIdParam from '@optimus/State/App/NavigationContext/hooks/useVaultIdParam';

function useVaultBoardsAsDictionary(): {
    [key: number]: IVideoPlaylistApiModel
 } {
    const vaultId = useVaultIdParam();
    const state: ITaskBoardContextModel = useTaskBoardStateContext();

    if (vaultId === null) {
        return {};
    }

    const boards =
        Object.entries(state.boards.byId)
            .filter(([key, value]) => value.parentVaultId === vaultId)
            .reduce((map, [key, value]) => ({
                ...map,
                [key]: value.board,
            }), {});

    return boards;
}

export default useVaultBoardsAsDictionary;